import { Activity } from '../api/types';
import { RUN_TYPES, isoLocal } from './format';

/** Monday of the week containing `date`, as a local YYYY-MM-DD. */
export function mondayOf(date: Date): string {
  const d = new Date(date);
  d.setHours(12, 0, 0, 0);
  const offset = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - offset);
  return isoLocal(d);
}

/** Kilometres per ISO week for the last `weeks` weeks (oldest first), counted from `now`. Empty weeks are 0. */
export function weeklyVolume(activities: Activity[], weeks = 4, now: Date = new Date()): Array<{ week: string; km: number }> {
  const buckets = new Map<string, number>();
  for (let w = weeks - 1; w >= 0; w--) {
    const start = new Date(now);
    start.setDate(start.getDate() - w * 7);
    buckets.set(mondayOf(start), 0);
  }
  activities.forEach(a => {
    if (a.distanceM == null) return;
    const key = mondayOf(new Date(a.startTime));
    if (buckets.has(key)) buckets.set(key, (buckets.get(key) ?? 0) + a.distanceM / 1000);
  });
  return Array.from(buckets, ([week, km]) => ({ week: week.slice(5), km: Number(km.toFixed(1)) }));
}

export function isRun(activity: Activity): boolean {
  return activity.activityType !== null && RUN_TYPES.includes(activity.activityType);
}
